"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = _default;

var _apolloLink = require("apollo-link");

var _createHttpLink = _interopRequireDefault(require("./createHttpLink"));

var _onError = _interopRequireDefault(require("./onError"));

var _createWsLink = _interopRequireDefault(require("./createWsLink"));

var _apolloUtilities = require("apollo-utilities");

function _default(options) {
  var links = [(0, _onError["default"])(options)];

  if (options.useSubscriptions) {
    var httpLink = (0, _createHttpLink["default"])(options);
    var wsLink = (0, _createWsLink["default"])(options);
    var link = (0, _apolloLink.split)(function (_ref) {
      var query = _ref.query;

      var _getMainDefinition = (0, _apolloUtilities.getMainDefinition)(query),
          kind = _getMainDefinition.kind,
          operation = _getMainDefinition.operation;

      return kind === 'OperationDefinition' && operation === 'subscription';
    }, wsLink, httpLink);
    links.push(link);
  } else {
    links.push((0, _createHttpLink["default"])(options));
  }

  return _apolloLink.ApolloLink.from(links);
}